import { render, staticRenderFns } from "./Kebutuhan.vue?vue&type=template&id=7c54fbd8&scoped=true&lang=html&"
import script from "./Kebutuhan.vue?vue&type=script&lang=js&"
export * from "./Kebutuhan.vue?vue&type=script&lang=js&"
import style0 from "./Kebutuhan.vue?vue&type=style&index=0&id=7c54fbd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c54fbd8",
  null
  
)

export default component.exports